import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Pagination } from '../../../../../../common/pagination'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { recommendSchema } from '../../../constants'
import {
  changeRevenuePage,
  selectIsLoadingRevenue,
  selectRevenueData,
  selectRevenueDataItem,
  selectRevenueIds,
  selectRevenuePage,
  selectRevenueTotalRecords,
  selectSelectedCompanyList,
} from '../store/slice'
import { getRecommendationRevenue } from '../store/thunk'
import { CustomScoreCell } from './common/CustomScoreCell'
import { FirstColumnCell } from './common/FirstColumnCell'

export const Revenue = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { formatCurrency } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const locale = useSelector((state) => state.i18n.locale)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)
  const revenueData = useSelector(selectRevenueData)
  const ids = useSelector(selectRevenueIds)
  const totalRecords = useSelector(selectRevenueTotalRecords)
  const isLoading = useSelector(selectIsLoadingRevenue)
  const page = useSelector(selectRevenuePage)

  useEffect(() => {
    dispatch(
      getRecommendationRevenue({
        OrganizationId: organizationId,
        Page: page,
        PageSize: 10,
      }),
    )
  }, [page, locale])

  const setPage = (value) => {
    dispatch(changeRevenuePage(value))
  }

  return (
    <Table
      ids={ids}
      getDataFromRedux={selectRevenueDataItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      autoHeightMax={450}
      schema={recommendSchema
        .filter((i) => i.colId !== 'vsicName')
        .map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              render: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={revenueData}
                  typeSelect={'selectOne'}
                />
              ),
              renderTh: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={revenueData}
                  typeSelect={'selectAll'}
                />
              ),
            }
          }

          if (index === 1) {
            return {
              ...item,
              render: (val) => (
                <TextEllipsisStaticLine
                  zIndexTooltip={15}
                  text={val}
                  isI18n={false}
                  lineClamp={2}
                />
              ),
            }
          }

          if ([2, 3].includes(index)) {
            return {
              ...item,
              render: (value) => formatCurrency({ value }),
            }
          }

          if ([6, 5].includes(index)) {
            return {
              ...item,
              render: (val) => (
                <CustomScoreCell
                  val={val}
                  typeCell={index === 5 ? 'CREDIT_RISK' : 'PERFORMANCE'}
                />
              ),
            }
          }

          return item
        })}
      renderPagination={() => (
        <Pagination
          page={page}
          total={totalRecords}
          setPage={setPage}
          className="pt2"
          isShowPageSize={false}
        />
      )}
    />
  )
}
